/**
 * Valide qu'une URL est une URL absolue http(s) sûre à ouvrir/cliquer.
 * Bloque les schémas dangereux (`javascript:`, `data:`, `file:`…) qui pourraient
 * arriver via des données tierces scrapées (event.url / source_url) et exécuter
 * du code si elles étaient passées à window.open ou rendues dans un <a href>.
 */
export function isSafeHttpUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  try {
    const u = new URL(url);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Nettoie une cible de redirection interne (param `next` du flux d'auth).
 * N'accepte qu'un chemin absolu interne, et rejette les chemins protocol-relative
 * (`//evil.com`) ou à backslash qui pourraient servir d'open-redirect.
 */
export function sanitizeInternalPath(next: string | null | undefined, fallback = '/decouvrir'): string {
  if (!next) return fallback;
  if (!next.startsWith('/')) return fallback;
  if (next.startsWith('//') || next.startsWith('/\\')) return fallback;
  return next;
}
